// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"d8b3d4fb","369":"734a0dd2"}[chunkId] + ".chunk.css";
};